export default "__VITE_PUBLIC_ASSET__c66c86ef__"